module.exports = __webpack_public_path__ + "static/media/essential-vocab.8493fcce.md";